import { Backdrop, Button, InputAdornment, TextField } from "@mui/material";
import React, { FunctionComponent, useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useAppDispatch, useAppSelector } from "../../redux/hooks/Hooks";
import { useSearchParams } from "react-router-dom";
import { IItemDetailMaster } from "./IItemDetailMaster";

import { raise_api_call_list_general_setting } from "../../redux/general-setting/list-general-setting-reducer";
import ItemDetailMasterList from "./ItemDetailMasterList";
import { clearCreateItemDetailMaster } from "../../redux/itemdetail-master/createItemDetailMaster";
import { clearEditItemDetailMaster } from "../../redux/itemdetail-master/editItemDetailMaster";
import { listItemDetailMasterStart } from "../../redux/itemdetail-master/listItemDetailMaster";
import { useCommonContext } from "../../Utils/commonContext";
import SearchImg from "../../assets/images/search.svg";
import DataNotFound from "../../assets/images/no_data_found.svg";

const ItemDetailMaster: FunctionComponent = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [itemDetail, setItemDetail] = useState<IItemDetailMaster>({});
  const [search, setSearch] = useState<string>("");
  const { setTitleContext, setShowBack, setOnBackClick, isMobile } =
    useCommonContext();

  const dispatch = useAppDispatch();
  const { data: itemDetailList, isLoading: listItemDetailLoading } =
    useAppSelector((state) => state.ListItemDetailMaster);
  const { isLoading: createItemDetailLoading, data: createItemDetail } =
    useAppSelector((state) => state.CreateItemDetailMaster);

  const { isLoading: editItemDetailLoading, data: editItemDetail } =
    useAppSelector((state) => state.EditItemDetailMaster);
  const listItemDetail =
    itemDetailList?.result?.map((itemDetail, index) => ({
      ...itemDetail,
      index: index + 1,
    })) ?? [];

  // list render
  useEffect(() => {
    dispatch(listItemDetailMasterStart(null));
  }, [createItemDetail, editItemDetail]);

  //clear create edit data and get the state list
  useEffect(() => {
    dispatch(raise_api_call_list_general_setting(""));
    return () => {
      dispatch(clearCreateItemDetailMaster());
      dispatch(clearEditItemDetailMaster());
    };
  }, []);

  useEffect(() => {
    if (listItemDetail?.length !== 0) {
      const itemDetailCheckById =
        searchParams.get("id") &&
        listItemDetail?.find(
          (item) => item.id === Number(searchParams.get("id"))
        );

      if (itemDetailCheckById) {
        setItemDetail(itemDetailCheckById);
      } else {
        setItemDetail({});
      }
    }
  }, [
    searchParams.get("id"),
    listItemDetail?.length,
    createItemDetail,
    editItemDetail,
  ]);

  const statusClassName = () => {
    return "approve_sts";
  };

  const handleBack = () => {
    setItemDetail({});
    setShowBack(false);
    setTitleContext("Item Detail Master");
  };

  useEffect(() => {
    setOnBackClick(() => handleBack);
    return () => {
      setShowBack(false);
      setTitleContext("");
    };
  }, []);

  useEffect(() => {
    if (itemDetail?.product) {
      setShowBack(true);
    }
  }, [itemDetail]);

  useEffect(() => {
    setTitleContext(itemDetail.product ?? "Item Detail Master");
  }, [itemDetail]);

  return (
    <div className="partner-details">
      <div className={`content_container`}>
        <div
          className={`mini_side_container`}
          style={{
            display: isMobile && itemDetail.id ? "none" : "initial",
          }}
        >
          <h5 className="f4 primary_text" style={{ paddingBottom: "10px" }}>
            Item Detail Master
          </h5>
          <div className="side_search_container">
            <TextField
              autoComplete="off"
              autoCorrect="off"
              spellCheck={false}
              placeholder="Search"
              className="side_search"
              onChange={(e) => {
                setSearch(e.target.value);
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <img src={SearchImg} alt="search" width="20px" />
                  </InputAdornment>
                ),
                style: {
                  borderRadius: "0px",
                  height: "45px",
                },
              }}
            />
            <Button
              className="side_filter"
              disableRipple
              onClick={() => {
                dispatch(listItemDetailMasterStart(null));
              }}
            >
              <FontAwesomeIcon
                style={{
                  fontSize: "22px",
                  color: "var(--white-color)",
                }}
                icon={["fas", "arrows-rotate"]}
              />
            </Button>
          </div>

          <div className="side_content_container">
            {listItemDetail &&
              listItemDetail
                .filter((item) => {
                  return Object.values(item)
                    .join("")
                    .toLowerCase()
                    .includes(search.toLowerCase());
                })
                .map((val, key) => (
                  <div
                    key={key + 1}
                    className={`side_content_card`}
                    onClick={() => {
                      val.id && setSearchParams({ id: val.id?.toString() });
                    }}
                  >
                    <div
                      className={`side_content_mini_card ${
                        val.id === itemDetail.id ? "active" : ""
                      }`}
                    >
                      <div className="f4 title">{val.product}</div>
                      <div className="side_content_footer side_content_footer2">
                        <h4 className="f4 subtitle">{val.barcode}</h4>
                        <h4 className={`f5 side_status ${statusClassName()}`}>
                          {val.order}
                        </h4>
                      </div>
                    </div>
                  </div>
                ))}
          </div>
        </div>

        <div
          className={`mini_content_container`}
          style={{
            display: isMobile && !itemDetail.id ? "none" : "initial",
          }}
        >
          {Object.keys(itemDetail).length === 0 ? (
            <div className="not_found_container">
              <img src={DataNotFound} alt="" />
              Please Select Any One Item Detail
            </div>
          ) : (
            <ItemDetailMasterList itemDetail={itemDetail} />
          )}
        </div>
      </div>

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={!!listItemDetailLoading}
      >
        <img
          style={{
            height: "150px",
          }}
          src={require("../../assets/images/3.gif")}
        ></img>
      </Backdrop>
    </div>
  );
};

export default ItemDetailMaster;
